<div class="page-content">

  <!-- HEADER -->
  <div class="page_header">
    <div class="page_header_text">
      <app-back-button></app-back-button>
      <div class="page_header_title_block">
        <h1>{{ posto?.nome ?? "Carregando..." }}</h1>
        <div class="page_header_meta" *ngIf="posto">
          <span class="posto-code"><i class="ri-hashtag"></i>{{ posto.codigo }}</span>
        </div>
      </div>
    </div>
    <div class="page_header_actions" *ngIf="posto">
      <button
        type="button"
        class="btn-suspender"
        [class.btn-activar]="!posto.ativo"
        (click)="suspenderPosto()"
        [disabled]="suspendendo"
        [pTooltip]="posto.ativo ? 'Suspender posto' : 'Activar posto'"
        tooltipPosition="bottom"
      >
        <i [class]="suspendendo ? 'fas fa-spinner fa-spin' : posto.ativo ? 'fas fa-pause-circle' : 'fas fa-play-circle'"></i>
        {{ posto.ativo ? "Suspender" : "Activar" }}
      </button>
      <button type="button" class="btn-web-secondary" (click)="editarPosto()">
        <i class="fas fa-pen"></i> Editar posto
      </button>
    </div>
  </div>
  <!-- SKELETON -->
  <div *ngIf="loadingPosto" class="skeleton-wrap">
    <p-skeleton height="120px" styleClass="mb-3"></p-skeleton>
    <p-skeleton height="200px"></p-skeleton>
  </div>

  <!-- HERO CARD -->
  <div class="posto-hero-card" *ngIf="!loadingPosto && posto">
    <div class="phc-left">
      <div class="phc-icon"><i class="ri-map-pin-2-fill"></i></div>
      <div class="phc-info">
        <div class="phc-tags">
          <span
            class="badge"
            [class]="posto.ativo ? 'badge-ativo' : 'badge-inativo'"
          >
            <i
              [class]="
                posto.ativo ? 'fas fa-check-circle' : 'ri-pause-circle-line'
              "
            ></i>
            {{ posto.ativo ? "ATIVO" : "INATIVO" }}
          </span>
          <app-status-badge
            [value]="posto.risco || ''"
            type="risco"
          ></app-status-badge>
        </div>
        <div class="phc-address">
          <i class="ri-map-pin-line"></i>
          <span>{{ posto.endereco || "Não informado" }}</span>
        </div>
      </div>
    </div>

    <div class="phc-kpis">
      <div class="phc-kpi" pTooltip="Efetivos atualmente associados ao posto" tooltipPosition="top">
        <i class="phc-kpi-icon ri-team-line blue"></i>
        <span class="pk-val" [class.warn]="efetivosAlocadosCount !== null && efetivosAlocadosCount < (posto.numEfetivosTurno ?? 0)">{{ efetivosAlocadosCount ?? 0 }}</span>
        <span class="pk-lbl">Ef. alocados</span>
      </div>
      <div class="phc-kpi">
        <i class="phc-kpi-icon fas fa-user blue"></i>
        <span class="pk-val">{{ posto.numEfetivosTurno ?? 0 }}</span>
        <span class="pk-lbl">Ef./turno</span>
      </div>
      <div class="phc-kpi">
        <i class="phc-kpi-icon fas fa-clock blue"></i>
        <span class="pk-val">{{ posto.numTurnosDia ?? 0 }}</span>
        <span class="pk-lbl">Turnos/dia</span>
      </div>
      <div class="phc-kpi" pTooltip="Total de escalas registadas neste posto" tooltipPosition="top">
        <i class="phc-kpi-icon fas fa-calendar-check green"></i>
        <span class="pk-val">{{ escalasCount ?? 0 }}</span>
        <span class="pk-lbl">Escalas</span>
      </div>
      <div class="phc-kpi" pTooltip="Total de checkpoints configurados neste posto" tooltipPosition="top">
        <i class="phc-kpi-icon ri-map-pin-2-line yellow"></i>
        <span class="pk-val">{{ checkpointsCount ?? 0 }}</span>
        <span class="pk-lbl">Checkpoints</span>
      </div>
      <div class="phc-kpi" pTooltip="Quantidade total de equipamentos associados ao posto" tooltipPosition="top">
        <i class="phc-kpi-icon ri-tools-line violet"></i>
        <span class="pk-val">{{ equipamentosCount ?? 0 }}</span>
        <span class="pk-lbl">Equipamentos</span>
      </div>
    </div>
  </div>

  <!-- TABS -->
  <div *ngIf="!loadingPosto && posto">
    <p-tabs [(value)]="activeTab">
      <p-tablist>
        <p-tab value="0"><span class="detail-tab-label"><i class="ri-information-line"></i> Informação</span></p-tab>
        <p-tab value="1">
          <span class="detail-tab-label"><i class="ri-team-line"></i> Efetivos Alocados</span>
          <span class="tab-badge" *ngIf="efetivosAlocadosCount !== null">{{ efetivosAlocadosCount }}</span>
        </p-tab>
        <p-tab value="2">
          <span class="detail-tab-label"><i class="ri-map-pin-2-line"></i> Checkpoints</span>
          <span class="tab-badge" *ngIf="checkpointsCount !== null">{{ checkpointsCount }}</span>
        </p-tab>
        <p-tab value="3">
          <span class="detail-tab-label"><i class="ri-tools-line"></i> Equipamentos</span>
          <span class="tab-badge" *ngIf="equipamentosCount !== null">{{ equipamentosCount }}</span>
        </p-tab>
        <p-tab value="4">
          <span class="detail-tab-label"><i class="ri-calendar-schedule-line"></i> Escala de Serviço</span>
          <span class="tab-badge" *ngIf="escalasCount !== null">{{ escalasCount }}</span>
        </p-tab>
      </p-tablist>
      <p-tabpanels>
        <!-- ── TAB 0: INFORMAÇÃO ── -->
        <p-tabpanel value="0">
          <app-posto-info-tab *ngIf="activeTab === '0'" [posto]="posto!"></app-posto-info-tab>
        </p-tabpanel>

        <!-- ── TAB 1: EFETIVOS ALOCADOS ── -->
        <p-tabpanel value="1">
          <app-posto-efetivos-alocados-tab
            [postoId]="currentPostoId"
            [posto]="posto"
            (countChange)="onEfetivosCountChange($event)"
          >
          </app-posto-efetivos-alocados-tab>
        </p-tabpanel>

        <!-- ── TAB 2: CHECKPOINTS ── -->
        <p-tabpanel value="2">
          <app-posto-checkpoints-tab
            *ngIf="activeTab === '2'"
            [postoId]="currentPostoId"
            (countChange)="onCheckpointsCountChange($event)"
          >
          </app-posto-checkpoints-tab>
        </p-tabpanel>

        <!-- ── TAB 3: EQUIPAMENTOS ── -->
        <p-tabpanel value="3">
          <app-posto-equipamentos-tab
            *ngIf="activeTab === '3'"
            [postoId]="currentPostoId"
            [posto]="posto"
            (countChange)="onEquipamentosCountChange($event)"
          >
          </app-posto-equipamentos-tab>
        </p-tabpanel>

        <!-- ── TAB 4: ESCALA DE SERVIÇO ── -->
        <p-tabpanel value="4">
          <app-posto-escala-tab
            [postoId]="currentPostoId"
            [openCreateOnInit]="openScaleDrawerOnInit"
            (countChange)="onEscalasCountChange($event)"
            (createDrawerOpened)="onScaleCreateDrawerOpened()"
          >
          </app-posto-escala-tab>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
